module.exports = __webpack_public_path__ + "static/media/container2.03547fad.jpg";